import React, { useEffect, useState } from 'react';
import { subscribeGlobalNetworkLoader } from '../utils/globalNetworkLoader';
import './GlobalNetworkLoaderOverlay.css';

const GlobalNetworkLoaderOverlay = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeGlobalNetworkLoader(setVisible), []);

  if (!visible) return null;

  return (
    <div className="global-network-loader-overlay" aria-live="polite" aria-busy="true">
      <div className="global-network-loader-spinner" />
    </div>
  );
};

export default GlobalNetworkLoaderOverlay;
